import * as React from 'react';
import { __ } from 'react-i18n';
import { FormInput, FormWrapper } from './FormInput';
import { StreetAndNumber } from './StreetAndNumber';
import { CityZip } from './CityZip';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';

interface Props {
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  onChange: any;
}

function Address({ street, streetNumber, city, zip, onChange }: Props) {
  return (
    <Wrapper>
      <StreetAndNumber
        street={street}
        streetNumber={streetNumber}
        onChange={onChange}
      />
      <CityZip city={city} zip={zip} onChange={onChange} />
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  flex-flow: row wrap;
`;

export { Address };
